export const brand = {
    default: "#004F9F",
    subtle: "#006DB6",
    strong: "#1C3885",
    accent: "#FFDD00",
};
